var map = {
	"./ccifs.json": [
		24593,
		4593
	],
	"./example.json": [
		2609,
		2609
	],
	"./spuerkeess.json": [
		15111,
		5111
	],
	"./ucanss.json": [
		98252,
		8252
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13220;
module.exports = webpackAsyncContext;